// A guide's agenda as a printable page, for a Manager (28 Oct 2026):
// /admin/:customer/guides/:guideId/agenda. The current version's points, to
// print or save as a PDF and send with the invitation in the Manager's own
// email. Opened in its own tab, outside the admin layout, so the printout is
// the agenda alone. A Manager's print names the guide's reviewers; a
// reviewer's (they may open it too, migration 000190) names the Managers only,
// since the reviewer list is the Manager's.

import React from 'react'
import { Alert, Box, CircularProgress } from '@mui/material'
import useAccount from '../../hooks/useAccount'
import useRouter from '../../hooks/useRouter'
import useAdminGuide from '../../hooks/useAdminGuide'
import useGuideReviewers from '../../hooks/useGuideReviewers'
import GuideAgendaPrint from '../../components/guided/GuideAgendaPrint'

const AdminGuideAgenda: React.FC = () => {
  const account = useAccount()
  const router = useRouter()
  const customer = (router.params.customer as string) || account.customer?.name || ''
  const guideId = (router.params.guideId as string) || ''
  const g = useAdminGuide({ customer, guideId })
  const isManager = Boolean(account.user?.role_permissions?.isManager)
  const reviewers = useGuideReviewers({ customer, guideId, enabled: isManager })
  const guide = g.guide

  if (g.isLoading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress size={28} /></Box>
  if (!guide) return <Box sx={{ maxWidth: 640, mx: 'auto', p: 3 }}><Alert severity="error">{g.error || 'This guide was not found.'}</Alert></Box>
  return (
    <GuideAgendaPrint
      title={guide.title}
      intro={guide.intro}
      goal={guide.goal}
      readersNote={guide.readers_note}
      reviewers={reviewers.reviewers}
      points={guide.points}
      onPrint={() => window.print()}
      back={{ label: 'Back to the guide', onClick: () => router.navigate('admin-guide', { customer, guideId }) }}
    />
  )
}

export default AdminGuideAgenda
